function createGraphProductBreadcrumb(categoryBreadcrumb, productName, brandName) {
  let name = productName;
  if (!!brandName) {
    name = productName.replace(brandName, "").trim();
  }
  return productName && categoryBreadcrumb ? { name } : null;
}
export {
  createGraphProductBreadcrumb
};
//# sourceMappingURL=create-graph-product-breadcrumb.js.map
